var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Click") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Click",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "click",
    transform: "translate(13.000000, 0.000000)",
    fill: "#4F8AF6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.729914,61.9245255 C71.923352,64.0479493 69.881478,65.4514452 67.6018155,65.4514452 L43.6173903,65.4514452 L53.9306931,86.9992885 C56.0997988,91.5306532 54.1661973,96.9528378 49.6112124,99.1139851 C45.0541716,101.273769 39.6017123,99.3491888 37.4316929,94.8166879 L26.7940292,72.5598246 L9.66229699,92.6146356 C8.6021854,93.8574658 7.06512638,94.5355797 5.48672278,94.5355797 C4.85147815,94.5355797 4.21257875,94.4254998 3.59515112,94.2017495 C1.43472547,93.421373 0,91.3761232 0,88.8763734 L0,5.45744981 C0,3.31266448 1.26340815,1.36013263 3.22533412,0.478402696 C5.19662545,-0.396509737 7.49913026,-0.0533622629 9.10722886,1.36013263 L71.0327304,55.9001284 C72.9583371,57.4022508 73.3466563,59.7883756 72.729914,61.9245255 Z",
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClick);
export default __webpack_public_path__ + "static/media/click.18590e5c60cfa35085f980e6f7879ffd.svg";
export { ForwardRef as ReactComponent };